import { useState, useMemo, useCallback } from 'react';

export interface SpecialityFilters {
  search: string;
  status: string;
  page: number;
  limit: number;
}

export const useSpecialityFilters = () => {
  const [filters, setFilters] = useState<SpecialityFilters>({
    search: '',
    status: 'all',
    page: 1,
    limit: 25,
  });

  const handleFilterChange = useCallback((key: keyof SpecialityFilters, value: string | number) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      // Reset page when filters change (except when changing page itself)
      ...(key !== 'page' && { page: 1 }),
    }));
  }, []);

  const queryParams = useMemo(() => ({
    page: filters.page,
    limit: filters.limit,
    search: filters.search || undefined,
    status: filters.status !== 'all' ? filters.status : undefined,
  }), [filters]);

  // Memoize the returned object to prevent re-renders
  return useMemo(() => ({
    filters,
    queryParams,
    handleFilterChange,
    setFilters,
  }), [filters, queryParams, handleFilterChange]);
}; 